import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS } from '../../store/file-pop-up/FilePopUpConstants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitsListener = ({ fetchVisits }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: (action) => action.type === SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
        effect: async (action) => {
          if (action.payload) {
            console.log('File tags updated, fetching visits...')
            fetchVisits()
          }
        },
      }),
    )

    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [dispatch, fetchVisits])

  return null
}
